import {
  useChannelStateContext,
  useChatContext,
  Avatar,
} from "stream-chat-react";
import { useMemo } from "react";
import React from "react";
import "../styles/CustomChannelHeader.css";

const CustomChannelHeader = () => {
  const { channel } = useChannelStateContext();
  const { client } = useChatContext();

  const getInitials = (name = "") => {
    return name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase())
      .join("")
      .slice(0, 2); // Max 2 letters
  };

  const otherMember = useMemo(() => {
    const members = Object.values(channel.state.members);
    return members.find((member) => member.user?.id !== client.userID)?.user;
  }, [channel, client]);

  if (!otherMember) return null;

  const initials = getInitials(otherMember.name || otherMember.id);

  return (
    <div className="custom-channel-header">
      <div className="header-content">
        {otherMember.photo ? (
          <Avatar
            image={otherMember.photo}
            name={otherMember.name || otherMember.id}
            size={50}
          />
        ) : (
          <div className="avatar-fallback">{initials}</div>
        )}
        <div className="channel-info">
          <div className="channel-name">
            {otherMember.name || otherMember.id}
          </div>
          <div
            className={`channel-status ${
              otherMember.online ? "online" : "offline"
            }`}
          >
            {otherMember.online ? "Online" : "Offline"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomChannelHeader;
